import CampaignCreate from 'modules/Services/Campaigns/Create/CampaignCreate'

export default CampaignCreate
